import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { PARENT_INFO, IMAGES } from "@/lib/content";

export default function ParentInfo() {
  return (
    <div data-testid="parent-info-page">
      <PageHeader
        overline="For parents"
        title="What every parent"
        italic="should know."
        subtitle="Understanding the process helps your child thrive. Here's how we work together as a team — in the pool and at home."
        image={IMAGES.parentBaby}
        imagePosition="center 78%"
      />

      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 space-y-4">
          {PARENT_INFO.map((item, i) => (
            <Reveal key={item.title} delay={i * 0.05}>
              <div className="grid md:grid-cols-12 gap-6 py-8 border-t" style={{ borderColor: "rgba(212,175,55,0.25)" }}>
                <div className="md:col-span-4">
                  <span className="font-display text-6xl block mb-2" style={{ color: "rgba(212,175,55,0.5)" }}>{String(i + 1).padStart(2, "0")}</span>
                  <h3 className="font-display text-2xl" style={{ color: "var(--navy)" }}>{item.title}</h3>
                </div>
                <p className="md:col-span-8 font-body font-light text-lg leading-relaxed" style={{ color: "var(--muted)" }}>{item.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
